import React, { useState, useEffect } from "react";

// Pre-load all images using Vite's glob import
const images = import.meta.glob('../../images/**/*', { eager: false });

const LazyImage = ({ name, ...rest }) => {
  const [src, setSrc] = useState('');

  useEffect(() => {
    let unmounted = false;

    (async () => {
      const imagePath = `../../images/${name}`;
      const imageLoader = images[imagePath];
      
      if (imageLoader) {
        const { default: lazySrc } = await imageLoader();
        !unmounted && setSrc(lazySrc);
      }
    })();

    return () => unmounted = true;
  }, [name]);

  return <img {...rest} src={src} />;
};

export default LazyImage;
